import React from 'react';

interface DownArrowProps {
  className?: string;
}

const DownArrow = ({ className }: DownArrowProps) => (
  <svg
    className={className}
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.3995 1.39945L6.44971 4.3492L1.49996 1.39945" strokeWidth="2" />
  </svg>
);

export default DownArrow;
